"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Cookies = require("js-cookie");
document.addEventListener('alpine:init', function () {
    Alpine.data('sitewideBanner', function (uniqueID) {
        return {
            cookieName: "alert-".concat(uniqueID),
            visible: false,
            init: function () {
                var _this = this;
                setTimeout(function () {
                    _this.visible = !Cookies.get(_this.cookieName);
                }, 1000);
            },
            close: function () {
                this.visible = false;
                Cookies.set(this.cookieName, '1', {
                    expires: 3, // days.
                });
                this.$store.app.track({
                    event: "close_sitewide-banner",
                    type: 'click',
                    module: 'sitewide-banner',
                    data: {
                        message: this.$refs.message.textContent.trim(),
                        cta: {
                            title: this.$refs.cta.textContent.trim(),
                            url: this.$refs.cta.href,
                        },
                    },
                });
            },
        };
    });
});
